export class SearchModel {
    enterprise: any;
    yearFrom: any;
    yearTo: any;
    make: any;
    model: any;
    color: any;
    style: any;
    auctionDateId: any;
    iscurrentAuction: any;
    storageLotId: any;
}